// removed by extract-text-webpack-plugin
module.exports = {"Loading":"Loading__1gvpX"};